import { render, staticRenderFns } from "./cornerstone-pic.vue?vue&type=template&id=018ae882&"
import script from "./cornerstone-pic.vue?vue&type=script&lang=ts&"
export * from "./cornerstone-pic.vue?vue&type=script&lang=ts&"
import style0 from "./cornerstone-pic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports